import { POWER_ZERO } from "../../../../../modules/EcommContent/ContactLensesEcommContent/constants.js";
const getRxEntryType = (sortedAttributesSet) => {
  const restRxCLPrescriptionValues = sortedAttributesSet.filter(
    (i) => i.name !== "power" && i.name !== "baseCurve" && i.name !== "diameter"
  );
  const diameterOrBaseCurve = sortedAttributesSet.filter(
    (i) => i.name === "baseCurve" || i.name === "diameter"
  );
  const power = sortedAttributesSet.find((i) => i.name === "power");
  const powerOptions = power ? Object.keys(power.attributeOptions) : [];
  if (restRxCLPrescriptionValues.length) {
    return "rx-entry-required";
  }
  if (diameterOrBaseCurve.some((i) => Object.keys(i.attributeOptions).length > 1)) {
    return "rx-entry-required";
  }
  if (powerOptions.length === 1 && powerOptions[0] === POWER_ZERO) {
    return "no-rx-entry";
  }
  if (powerOptions.length > 1 && powerOptions.includes(POWER_ZERO)) {
    return "rx-entry-optional";
  }
  return "rx-entry-required";
};
export {
  getRxEntryType
};
//# sourceMappingURL=get-rx-entry-type.js.map
